export default "__VITE_ASSET__DO_Wb9I___"